import useMetadataStore from "@/stores/metaDataStore";

interface PillTriggerProps {
  setIsOpen: (isOpen: boolean) => void;
}

export const PillTrigger = ({ setIsOpen }: PillTriggerProps) => {
  const { offerMetadata } = useMetadataStore();
  return (
    <button
      onClick={() => setIsOpen(true)}
      className="chatbot-trigger-button bg-black text-white h-14 px-8 shadow-lg transition-colors flex items-center justify-center text-2xl leading-tight whitespace-nowrap"
      style={{
        borderRadius: "9999px", // Ensures full rounding horizontally
        height: "56px", // Explicit height to maintain proportions
        paddingLeft: "32px",
        paddingRight: "32px",
        minWidth: "fit-content", // Expands dynamically with text
      }}
    >
      {offerMetadata?.user?.firstName
        ? `${offerMetadata?.user?.firstName}'s Offer`
        : "Your Offer"}
    </button>
  );
};
